import { Gameplay } from "appworks/model/gameplay/gameplay";
import { AuthRequestPayload } from "appworks/model/gameplay/requests/auth-request-payload";
import { Model } from "appworks/model/model";
import { RealityMode } from "appworks/model/settings/settings-model";
import { RequestBuilder } from "appworks/server/builders/request-builder";
import { SocketRequest } from "appworks/server/connectors/socket-connector";
import { gameiomModel } from "gameiom/model/gameiom-model";

export class AuthRequestBuilder implements RequestBuilder {
    public filter(request: any): boolean {
        return request instanceof AuthRequestPayload;
    }

    public build(gameplay: Gameplay, request: any): SocketRequest {
        const { playMode } = Model.read().settings;
        const body = {
            platform: {
                sessionToken: gameiomModel.sessionToken,
                username: gameiomModel.username,
                providerId: gameiomModel.providerId,
                operatorId: gameiomModel.operatorId,
                gameId: gameiomModel.gameId
            },
            publicState: {
                action: "init",
                userName: gameiomModel.username,
                gameId: gameiomModel.gameId,
                mode: playMode === RealityMode.REAL ? "realPlay" : "freePlay",
                jurisdiction: gameiomModel.jurisdiction
            }
        };

        return new SocketRequest(body, gameiomModel.url);
    }
}
